import { getApiBaseUrl } from '../config/api';

/** URL نمایش فایل‌های آپلودشده روی API (محصولات، لوگوی همکار، …) */
export function mediaUrl(relativePath) {
  if (!relativePath || typeof relativePath !== 'string') return '';
  const s = relativePath.trim();
  if (!s) return '';
  if (s.startsWith('http://') || s.startsWith('https://') || s.startsWith('data:')) return s;
  if (s.startsWith('/uploads/')) return `${getApiBaseUrl()}${s}`;
  return `${getApiBaseUrl()}/uploads/${s.replace(/^\/+/, '')}`;
}

export function traderPartnerLogoUrl(ref) {
  if (!ref || typeof ref !== 'string') return '';
  const s = ref.trim();
  if (!s) return '';
  if (s.startsWith('http://') || s.startsWith('https://')) return s;
  if (s.startsWith('data:image/')) return s;
  if (s.includes('/uploads/trader-partners/')) {
    return mediaUrl(s.startsWith('/') ? s : `/uploads/trader-partners/${s.split('/').pop()}`);
  }
  return mediaUrl(`/uploads/trader-partners/${s}`);
}

/** لوگو / عکس پروفایل کسب‌وکار در کاتالوگ (guild) */
export function businessProfileImageUrl(ref) {
  if (!ref || typeof ref !== 'string') return '';
  const s = ref.trim();
  if (!s || s === 'null') return '';
  if (s.startsWith('http://') || s.startsWith('https://') || s.startsWith('data:image/')) return s;
  if (s.startsWith('/uploads/')) return mediaUrl(s);
  if (s.includes('/uploads/business/')) {
    return mediaUrl(s.startsWith('/') ? s : `/uploads/business/${s.split('/').pop()}`);
  }
  return mediaUrl(`/uploads/business/${s}`);
}

/** لوگو / عکس پروفایل کاربر یا کسب‌وکار (guild) */
export function profileImageUrl(ref) {
  if (!ref || typeof ref !== 'string') return '';
  const s = ref.trim();
  if (!s || s === 'null') return '';
  if (s.startsWith('http://') || s.startsWith('https://') || s.startsWith('data:image/')) return s;
  if (s.startsWith('/uploads/')) return mediaUrl(s);
  if (s.includes('/uploads/user-profile/')) {
    return mediaUrl(s.startsWith('/') ? s : `/uploads/user-profile/${s.split('/').pop()}`);
  }
  if (s.includes('/uploads/business/')) {
    return mediaUrl(s.startsWith('/') ? s : `/uploads/business/${s.split('/').pop()}`);
  }
  return mediaUrl(`/uploads/user-profile/${s}`);
}

/** لوگو / عکس پروفایل بازرگان */
export function traderProfileImageUrl(ref) {
  if (!ref || typeof ref !== 'string') return '';
  const s = ref.trim();
  if (!s || s === 'null') return '';
  if (s.startsWith('http://') || s.startsWith('https://') || s.startsWith('data:image/')) return s;
  if (s.includes('/uploads/trader-profile/')) {
    return mediaUrl(s.startsWith('/') ? s : `/uploads/trader-profile/${s.split('/').pop()}`);
  }
  if (s.includes('/uploads/business/')) {
    return mediaUrl(s.startsWith('/') ? s : `/uploads/business/${s.split('/').pop()}`);
  }
  return mediaUrl(`/uploads/trader-profile/${s}`);
}

export function productImageUrl(images, apiBase) {
  const base = apiBase || getApiBaseUrl();
  if (!Array.isArray(images) || !images[0]) return null;
  const first = images[0];
  if (typeof first === 'string' && (first.startsWith('http') || first.startsWith('data:'))) return first;
  return `${base.replace(/\/+$/, '')}/uploads/products/${first}`;
}
